import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';

export const ArrowDropDownIcon = createSvgIcon(<path d="M7 10l5 5 5-5z" />, 'ArrowDropDownIcon');
